import { render, staticRenderFns } from "./BasePwdPaySetup.vue?vue&type=template&id=63084b2c&scoped=true&"
import script from "./BasePwdPaySetup.vue?vue&type=script&lang=js&"
export * from "./BasePwdPaySetup.vue?vue&type=script&lang=js&"
import style0 from "./BasePwdPaySetup.vue?vue&type=style&index=0&id=63084b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63084b2c",
  null
  
)

export default component.exports